<template>
  <v-container fluid>
    <v-layout row>
      <v-flex>
        <v-card>
          <v-card-title primary-title class="primary white--text headline">
            Cache Memory Usage
            <v-spacer></v-spacer>
            <v-btn medium depressed flat icon color="white" 
              @click="fetchMemoryUsage()">
              <v-icon medium>cached</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-0">
            <v-data-table
            :headers="cacheHeaders"
            :items="cacheItems"
            hide-actions
            :loading="cacheLoading">
              <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
              <template slot="items" slot-scope="props">
                <td>{{ props.item.name}}</td>
                <td>{{ props.item.count}}</td>
                <td>{{ props.item.memoryUsage}} Bytes</td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex>
        <v-card>
          <v-card-title primary-title class="primary white--text headline">
            Ray Memory Usage
            <v-spacer></v-spacer>
            <v-btn medium depressed flat icon color="white" 
              @click="fetchRayUsage()">
              <v-icon medium>cached</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-0">
            <v-data-table
            :headers="rayHeaders"
            :items="rayItems"
            hide-actions
            :loading="rayLoading">
              <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
              <template slot="items" slot-scope="props">
                <td>{{ props.item.name}}</td>
                <td>{{ props.item.log}}</td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex>
        <v-card>
          <v-card-title primary-title class="primary white--text headline">
            Queue Usage
            <v-spacer></v-spacer>
            <v-btn medium depressed flat icon color="white" 
              @click="fetchQueueUsage()">
              <v-icon medium>cached</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-0">
            <v-data-table
            :headers="queueHeaders"
            :items="queueItems"
            hide-actions
            :loading="queueLoading">
              <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
              <template slot="items" slot-scope="props">
                <td>{{ props.item.name}}</td>
                <td>{{ props.item.qsize}}</td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex>
        <v-card>
          <v-card-title primary-title class="primary white--text headline">
            System Usage
            <v-spacer></v-spacer>
            <v-btn medium depressed flat icon color="white" 
              @click="fetchSystemUsage()">
              <v-icon medium>cached</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-0">
            <v-data-table
            :headers="systemHeaders"
            :items="systemItems"
            hide-actions
            :loading="systemLoading">
              <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
              <template slot="items" slot-scope="props">
                <td>{{ props.item.name}}</td>
                <td>{{ props.item.usage}}</td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      cacheHeaders: [
        {text: 'Name', sortable: true, value: 'name'},
        {text: 'Count', sortable: true, value: 'count'},
        {text: 'Memory Usage', sortable: true, value: 'memoryUsage'}
      ],
      rayHeaders: [
        {text: 'Name', sortable: true, value: 'name'},
        {text: 'Log', sortable: false, value: 'log'}
      ],
      queueHeaders: [
        {text: 'Name', sortable: true, value: 'name'},
        {text: 'Q Size', sortable: false, value: 'qsize'}
      ],
      systemHeaders: [
        {text: 'Name', sortable: true, value: 'name'},
        {text: 'Usage', sortable: false, value: 'usage'}
      ],
      cacheItems: [],
      rayItems: [],
      queueItems: [],
      systemItems: [],
      dialog: false,
      rayLoading: false,
      cacheLoading: false,
      queueLoading: false,
      systemLoading: false,
      pagination: {
        sortBy: 'name'
      }
    }
  },
  created () {
    this.fetchMemoryUsage()
    this.fetchRayUsage()
    this.fetchQueueUsage()
    this.fetchSystemUsage()
  },
  methods: {
    fetchMemoryUsage () {
      this.cacheLoading = true
      this.cacheItems = []
      this.axios.get('/detailed-health/mem-usage')
        .then(response => {
          response.data.forEach(cacheItem => {
            this.cacheItems.push({
              name: cacheItem.name,
              count: cacheItem.count,
              memoryUsage: cacheItem.memory_usage
            })
          })
        })
        .catch(error => {
          this.handleAxiosError(error)
        })
        .finally(() => {
          this.cacheLoading = false
        })
    },
    fetchRayUsage () {
      this.rayLoading = true
      this.rayItems = []
      this.axios.get('/detailed-health/ray-usage')
        .then(response => {
          response.data.forEach(rayItem => {
            this.rayItems.push({
              name: rayItem.name,
              log: rayItem.log
            })
          })
        })
        .catch(error => {
          this.handleAxiosError(error)
        })
        .finally(() => {
          this.rayLoading = false
        })
    },
    fetchQueueUsage () {
      this.queueLoading = true
      this.queueItems = []
      this.axios.get('/detailed-health/queue-usage')
        .then(response => {
          response.data.forEach(queueItem => {
            this.queueItems.push({
              name: queueItem.name,
              qsize: queueItem.qsize
            })
          })
        })
        .catch(error => {
          this.handleAxiosError(error)
        })
        .finally(() => {
          this.queueLoading = false
        })
    },
    fetchSystemUsage () {
      this.systemLoading = true
      this.systemItems = []
      this.axios.get('/detailed-health/system-usage')
        .then(response => {
          response.data.forEach(systemItem => {
            this.systemItems.push({
              name: systemItem.name,
              usage: systemItem.usage
            })
          })
        })
        .catch(error => {
          this.handleAxiosError(error)
        })
        .finally(() => {
          this.systemLoading = false
        })
    }
  }
}
</script>

<style>

</style>
